export default "__VITE_ASSET__CP7QzgnX__"